import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/outcome`;

export interface UpdateFileOutcomeCommandPayload {
  fileId: string;
  closing: string;
}

export const updateFileOutcomeRequest = ({
  fileId,
  closing,
}: UpdateFileOutcomeCommandPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { closing },
  },
});

async function updateFileOutcomeCommand({
  fileId,
  closing,
}: UpdateFileOutcomeCommandPayload): Promise<BaseBackResponse> {
  try {
    return await executeQuery<BaseBackResponse>(
      updateFileOutcomeRequest({ fileId, closing }),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default updateFileOutcomeCommand;
